import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import "react-datepicker/dist/react-datepicker.css";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";

const DataAndColorPicker = observer((props) => {
  // =======================================================================
  // Statusvariablen
  const [selectedId, setSelectedId] = useState(
    props.selectedPoints[props.index]
  );

  useEffect(() => {
    setSelectedId(props.selectedPoints[props.index].id);
  }, [props.selectedPoints[props.index]].id);

  // =======================================================================
  // Funktion, die aufgerufen wird, wenn eine Option im Dropdown ausgewählt wird
  const handleSelect = (event) => {
    const value = event.target.value;
    setSelectedId(value);
    let newSelectedPoints = [...props.selectedPoints];
    newSelectedPoints[props.index].id = value;
    props.setSelectedPoints(newSelectedPoints);
  };

  // Funktion, die aufgerufen wird, wenn eine Farbe geändert wird
  const colorSelect = (event) => {
    const color = event.target.value;
    let newSelectedPoints = [...props.selectedPoints];
    newSelectedPoints[props.index].color = color;
    props.setSelectedPoints(newSelectedPoints);
  };

  // nur numerische Datenpunkte anzeigen
  const boolTypes = ["BOOL"];
  const numTypes = [
    "USINT",
    "UINT",
    "UDINT",
    "ULINT",
    "UINT",
    "INT",
    "DINT",
    "LINT",
    "BYTE",
    "WORD",
    "DWORD",
    "LWORD",
    "REAL",
    "LREAL",
  ];

  const numericDataPoints = props.historicPoints.filter((item) =>
    numTypes.includes(item.type)
  );

  const booleanDataPoints = props.historicPoints.filter((item) =>
    boolTypes.includes(item.type)
  );

  // Festlegen des Indexes für die gewählte Sprache
  let sortLanguageIndex;
  if (globalVars.language === "de") {
    sortLanguageIndex = 0;
  } else if (globalVars.language === "it") {
    sortLanguageIndex = 1;
  } else if (globalVars.language === "en") {
    sortLanguageIndex = 2;
  } else {
    sortLanguageIndex = 0; // Fallback
  }

  // Sortieren der Daten nach dem Namen in der gewählten Sprache
  let sortedData;
  if (props.type === "num") {
    sortedData = numericDataPoints.sort((a, b) =>
      a.name[sortLanguageIndex].localeCompare(b.name[sortLanguageIndex])
    );
  } else if (props.type === "bool") {
    sortedData = booleanDataPoints.sort((a, b) =>
      a.name[sortLanguageIndex].localeCompare(b.name[sortLanguageIndex])
    );
  }

  // =======================================================================
  // Elemente skaliert anzeigen
  const scaleSelectWidth = 0.74626865671641791044776119402985;
  const scaleInputWidth = 0.22388059701492537313432835820896;
  const scaleMargin = 0.02985074626865671641791044776119;

  // =======================================================================
  // Auswahl Datenpunkte und Farbe rendern
  return (
    <div
      style={{
        position: "absolute",
        top: props.style.top,
        left: props.style.left,
        display: "flex",
        alignItems: "center",
      }}
    >
      <select
        style={{
          background: "#0f1117",
          border: "1px solid #2a3448",
          borderRadius: "6px",
          color: "#cbd5e1",
          outline: "none",
          cursor: "pointer",
          height: props.style.height,
          width: `${parseFloat(props.style.width) * scaleSelectWidth}px`,
          fontSize: props.style.fontSize,
        }}
        onChange={handleSelect}
        value={selectedId}
      >
        <option value=""></option> {/* Leere Option hinzugefügt */}
        {sortedData.map((item) => (
          <option key={item.id} value={item.id}>
            {language.displayText(item.name)}
          </option>
        ))}
      </select>

      <input
        style={{
          margin: "0 0 0 auto",
          marginLeft: `${parseFloat(props.style.width) * scaleMargin}px`,
          height: props.style.height,
          width: `${parseFloat(props.style.width) * scaleInputWidth}px`,
        }}
        type="color"
        value={props.selectedPoints[props.index].color}
        onChange={colorSelect}
      />
    </div>
  );
});

export default DataAndColorPicker;
